// extracted by mini-css-extract-plugin
export var emptyState = "_5u-d";
export var statCard = "_5u-c";
export var table = "_5u-0";
export var tableCell = "_5u-4";
export var tableCellClickable = "_5u-5 _5u-4";
export var tableCellDefault = "_5u-6 _5u-4";
export var tableCellEmpty = "_5u-8";
export var tableCellWithValue = "_5u-7";
export var tableContainer = "_5u-e";
export var tableHeaderWeight = "_5u-1";
export var tableHeaderZone = "_5u-2";
export var tableRowHeader = "_5u-3";
export var viewModeButton = "_5u-9";
export var viewModeButtonActive = "_5u-a _5u-9";
export var viewModeButtonInactive = "_5u-b _5u-9";